import React, { Component, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./UpdateBillingView.component.css";
import { Link } from "react-router-dom";
import Loader from "../../common/loader/Loader";

import ErrorView from "../../common/error-view/ErrorView";
import { AppLinks } from "../../../constants/app-links";

export class UpdateBillingView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };

    this.hideLoader = this.hideLoader.bind(this);

      this.billingStatus = '';
  }

  hideLoader() {
    this.setState({ loadingForm: false })
    }

  dateSuffix = (day) => {
    let j = day % 10,
      k = day % 100;
    if (j === 1 && k !== 11) {
      return day + "st";
    }
    if (j === 2 && k !== 12) {
      return day + "nd";
    }
    if (j === 3 && k !== 13) {
      return day + "rd";
    }
    return day + "th";
  }

  openManagePaymentMethods = () => {
    this.props.openManagePayments('managePaymentMethods');
  }

  openManageRecurringPayments = () => {
    this.props.openManagePayments('manageRecurringPayments');
    }

    scrollToMiddleOfBrowser() {
        const scrollY = document.body.scrollHeight / 4.5 - window.innerHeight / 4;
        window.scrollTo({
            top: scrollY,
            behavior: 'smooth' // Optional for smooth animation
        });
    }

  componentDidMount() {

      var self = this;

    setTimeout(() => {
        this.hideLoader();
        this.scrollToMiddleOfBrowser();
    }, 500);   

    switch (this.props.userAccountDetails.Status) {
      case 'Active':
        this.billingStatus = 'Current';
        break;
      case 'Suspended':
        this.billingStatus = 'Suspended';
        break;
      case 'Cancel Full':
      case 'Cancel Prorata':
        this.billingStatus = 'Canceled';
        break;
      default:
        this.billingStatus = 'Unknown';
      }
  }
  
  render() {
    return (
        <div className="container"> 
        <div className="d-flex flex-column update-billing-container">
          {this.props.serverError && <ErrorView>{this.props.errorText ? this.props.errorText :
            <span>Unable to update billing details due to an error. Please <Link to={AppLinks.others.contact}>click here</Link> to contact us.</span>
          }</ErrorView>}
          {this.props.userAccountDetails ?
                    (<div>
                       {/* Desktop View*/}
                        <div class="d-none d-md-block ">
                        <h1 className="page-title manage-payment-label">Manage Payments </h1>
                          <div class="row">
                  <div className="col-lg-8 payment-section">
                  <div className="card-header-label">
                    <img class="desktop-dollor-icon" src="/assets/images/dollar_icon.svg" alt="" /> Payment Information
                    </div>
                    <div className="card-body p-4">
                       <div className="card-payment-label">BILLING STATUS</div>
                        <div className="card-payment-value" id="BillingStatus">{ this.billingStatus }</div>
                        <div className="card-payment-label">MONTHLY PREMIUM</div>
                                <div className="monthly-premium-value">${this.props.userAccountDetails.MonthlyPremium.substr(1)} <span className="monthly-detail-label">(on the 
                          <span id="BillingDay"> { this.dateSuffix(this.props.userAccountDetails.BillingDay) }</span> of each month)</span></div>
                  
                      <div className="fee-info">
                      <div className="card-Fees-Title">About card processing fees:</div>
                          <div className="card-fee-description">
                           Subject to state law requirements, card payments will be processed by One Inc, a third-party <br></br> payment processor, and a processing fee of 2.99% will be charged for using their digital <br></br> payment platform. To avoid the fee associated with
                          paying by card through the One Inc. <br></br> platform, you can pay via bank account (ACH) instead.
                      </div>
                      </div>
                                </div>
                                <div className="button-container button-bottom-container">
                     <button className="btn-primary" onClick={this.openManagePaymentMethods}>Manage Payment Methods</button>
                     <button className="btn-outline" onClick={this.openManageRecurringPayments}>Manage Recurring Payments</button>
                      </div>
                     </div>
                     <div class="right-column col-lg-4 d-none d-lg-flex flex-column mhide"></div>
                     <br /><br /><br /><br />
                      <div className="m-4">
                                <hr className="d-none d-md-block" />
                                {/*<label className="d-none d-md-block note-text ">*/}
                                {/*    Note: Updating your billing address does not change your*/}
                                {/*    physical address.*/}
                                {/*</label>*/}
                                <hr className="d-none d-md-block margin-bottom" />
                            </div>
                     </div>
                        </div>
                        <div class="d-md-none">
                        {/*MOBILE VIEW*/}
                       
                            <h1 className="page-title mobile-manage-payment-label" style={{ marginLeft: "-14px" }}>Manage Payments</h1>
                        <div class="row mobile-row">
                                <div className="col-lg-8 payment-section mobile-payment-card">
                       <div className="mobile-card-header-label">
                        <img src="/assets/images/dollar_icon.svg" class="money-icon-mobile" alt=""/> Payment Information
                    </div>
                       <div className="card-body p-4 margin-top16px">
                         <div className="mobile-card-payment-label">BILLING STATUS</div>
                          <div className="mobile-card-payment-value" id="BillingStatus">{ this.billingStatus }</div>
                         <div className="mobile-card-payment-label">MONTHLY PREMIUM</div>
                                        <div className="mobile-monthly-premium-value">${this.props.userAccountDetails.MonthlyPremium.substr(1)} <span className="mobile-monthly-detail-label">(on the 
                          <span id="BillingDay"> { this.dateSuffix(this.props.userAccountDetails.BillingDay) }</span> of each month)</span></div>
                  
                      <div className="fee-info">
                           <div className="mobile-card-Fees-Title">About card processing fees:</div>
                              <div className="mobile-card-fee-description">
                           Subject to state law requirements, card payments will be processed by One Inc, a third-party payment processor, and a processing fee of 2.99% will be charged for using their digital payment platform. To avoid the fee associated with
                          paying by card through the One Inc. platform, you can pay via bank account (ACH) instead.
                      </div>
                      </div>
                                    </div>

                                    <div className="button-container mobile-button-bottom-container mobile-btn-bottom">
                                        <button className="btn-primary manage-payment-mobile-btn btn-outline-mobile width-btn" onClick={this.openManagePaymentMethods}>Manage Payment Methods </button>
                                        <button className="btn-outline btn-outline-mobile" onClick={this.openManageRecurringPayments}>Manage Recurring Payments</button>
                      </div>
                     </div>
                     <div class="right-column col-lg-4 d-none d-lg-flex flex-column mhide"></div>
                     <br /><br /><br /><br />
                      <div className="m-4">
                                <hr className="d-none d-md-block" />
                                {/*<label className="d-none d-md-block note-text ">*/}
                                {/*    Note: Updating your billing address does not change your*/}
                                {/*    physical address.*/}
                                {/*</label>*/}
                                <hr className="d-none d-md-block margin-bottom" />
                            </div>
                     </div>
                         
                        </div>
                    </div>
            )
            : (
              this.props.userAccountFetchError && (
                <ErrorView>
                  {this.props.userAccountFetchError.errorMessage ||
                    "Unable to fetch information right now."}
                </ErrorView>
              )
            )}
          {(this.props.sendingToServer || this.props.userAccountDetailsFetching || this.state.loadingForm) && (
            <Loader position="absolute" fullPage={true} zIndex="300" />
          )}
        </div>
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
    },
    dispatch
  )
});

export default connect(
  mapDispatchToProps
)(UpdateBillingView);
